import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const defaultLang = window.location.host.includes("rgdrone.co.il")
      ? "he"
      : "en";
    const lang = localStorage.getItem("language") || defaultLang;
    i18n.changeLanguage(lang);
    if (lang === "he") {
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const onChangeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);

    if (lang === "he") {
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
    }
  };

  return (
    <header className={scrolled ? "header scrolled" : "header"}>
      <a href="#home" className="logo">
        <img src="/logo.png" alt="1" />{" "}
      </a>

      {/* Desktop Menu */}
      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <a href="#about">{t("about")}</a>
        <a href="#services">{t("services")}</a>
        <a href="#gallery">{t("gallery")}</a>
        <a href="#contact">{t("contact")}</a>
        <div className="lang-switcher">
          <span className="cur-poi" onClick={() => onChangeLang("en")}>
            EN
          </span>{" "}
          |{" "}
          <span className="cur-poi" onClick={() => onChangeLang("he")}>
            HE
          </span>
        </div>
      </nav>

      {/* Hamburger Icon */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      {/* Full-Screen Menu Overlay (Mobile) */}
      {menuOpen && (
        <div className="overlay">
          <nav className="overlay-menu">
            <a href="#about" onClick={() => setMenuOpen(false)}>
              {t("about")}
            </a>
            <a href="#services" onClick={() => setMenuOpen(false)}>
              {t("services")}
            </a>
            <a href="#gallery" onClick={() => setMenuOpen(false)}>
              {t("gallery")}
            </a>
            <a href="#contact" onClick={() => setMenuOpen(false)}>
              {t("contact")}
            </a>
            <div className="lang-switcher">
              <span className="cur-poi" onClick={() => onChangeLang("en")}>
                EN
              </span>{" "}
              |{" "}
              <span className="cur-poi" onClick={() => onChangeLang("he")}>
                HE
              </span>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
